module.exports = __webpack_public_path__ + "img/appleStoreBg.85bbafab.png";